import React from 'react';
import { Hero } from './components/Hero';
import { SeasonShowCarousel } from './components/SeasonShowCarousel';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { BuyerReviews } from './components/BuyerReviews';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-rink text-white font-sans selection:bg-amber selection:text-amber-ink" data-id="element-0" data-mp="3mjgczu7zmpqf">
      <MetaPixel data-id="element-1" data-mp="5yi8qe3h5da" />
      <main data-id="element-2" data-mp="6hovayao7c0">
        <Hero data-id="element-3" data-mp="4wvvprmowg9" />
        <SeasonShowCarousel data-id="element-4" data-mp="4n725ibkvc5" />
        <SocialProofBar data-id="element-5" data-mp="82ovg3doih9" />
        <PainGrid data-id="element-6" data-mp="2zld2jatxbhc2" />
        <ProductReveal data-id="element-7" data-mp="2zlv8x0aavbxp" />
        <Tomes data-id="element-8" data-mp="2zmo3z3zwcd00" />
        <Bonuses data-id="element-9" data-mp="2zn69yscd25l4" />
        <LookInside data-id="element-10" data-mp="33mouhn09senf" />
        <ValueStack data-id="element-11" data-mp="33m5a7zn5de68" />
        <Urgency data-id="element-12" data-mp="33nq5jrhad155" />
        <Pricing data-id="element-13" data-mp="33n6xd2hftr4b" />
        <BuyerReviews data-id="element-14" data-mp="33orki71fa7s5" />
        <Testimonials testimonials={shortTestimonials} title="You're not the only one" subtitle="Real words from skating coaches in public forums. They are not reviews of this pack — they are the reason it exists." background="white" data-id="element-15" data-mp="38m1fs3bhtdnw" />
        <Guarantee data-id="element-16" data-mp="nxwv3et6z8sj" />
        <Faq data-id="element-17" data-mp="sudnwmbc6bby" />
        <Testimonials testimonials={moreTestimonials} eyebrow="Where the lanes came from" title="The idea started rinkside" subtitle="Coaches were already drawing circuits on the ice and splitting the rink by speed. The 3-Lane Lesson turns that into a system you can run every week." background="glacier" data-id="element-18" data-mp="stuclog6yl6w" />
        <CostOfInaction data-id="element-19" data-mp="85l3ewu838bu" />
        <Close data-id="element-20" data-mp="851n1kk80rzx" />
      </main>
      <Footer data-id="element-21" data-mp="86w5ms80s80u" />
      <PurchaseNotifications data-id="element-22" data-mp="86cm572q1bkp" />
    </div>;
}